import React from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchTaiKhoanBank } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank";

import { AddTaiKhoanDesktopBtn } from "./AddTaiKhoanDesktopBtn.js";
export const TableDanhSach = ({ dataDanhSach, onSearch }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanBank);
  const handlePageChange = (pageNumber) => {
    dataSearch.iPageIndex = pageNumber;
    dispatch(
      updateDataSearchTaiKhoanBank({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    onSearch();
  };
  const handlePageSizeChange = (pageSize) => {
    dataSearch.iPageSize = pageSize;
    dataSearch.iPageIndex = 1;
    dispatch(
      updateDataSearchTaiKhoanBank({
        ...dataSearch,
        iPageSize: pageSize,
        iPageIndex: 1,
      })
    );
    onSearch();
  };
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div style={{paddingLeft :"20px", paddingTop :"20px"}}>
          {" "}
          <AddTaiKhoanDesktopBtn data={""} onSearch={onSearch} />
        </div>
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile  table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">[ {dataDanhSach.iTotal} ]</span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-29-sm">
                    <p className="text-center">Họ và tên</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-15-sm">
                    <p className="tab-header  text-center">Số tài khoản</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-15-sm">
                    <p className="tab-header  text-center">Ngân hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-15-sm">
                    <p className="tab-header  text-center">Liên kết</p>
                  </div>

                  <div className="custom-table-header flex-basis-15 flex-basis-10-sm  action-cell">
                    <p className="tab-header text-center">Thao tác</p>
                  </div>
                </div>

                <div
                  className="custom-table-body"
                >
                  {typeof dataDanhSach.List != "undefined" &&
                    dataDanhSach.List.length > 0 && (
                      <ContentTable
                        dataDanhSach={dataDanhSach}
                        onSearch={onSearch}
                      />
                    )}
                  {typeof dataDanhSach.List === "undefined" ||
                    (dataDanhSach.List.length === 0 && (
                      <div>Không có dữ liệu</div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.iPageIndex}
            pageSize={dataSearch.iPageSize}
            totalCount={dataDanhSach.iTotal}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
